<template>
  <div id="App">
    <HeaderView />

    <!-- Кнопки переключения языков -->
    <div class="lang-switcher" style="display: none;">
      <button @click="setLang('ru')">RU</button>
      <button @click="setLang('uz')">UZ</button>
    </div>

    <div class="app-container">
      <router-view />
    </div>

    <FooterView/>
  </div>
</template>

<script>
import HeaderView from '@/views/HeaderView.vue';
import FooterView from '@/views/FooterView.vue';

export default {
  name: 'HomeView',
  components: {
    HeaderView,
    FooterView
  },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang; // переключаем язык
    }
  },
  mounted() {
    document.title = 'MedexSolution'
  }
}
</script>

<style scoped>
.lang-switcher {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 20px;
}

.lang-switcher button {
  border: none;
  background: var(--green);
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.lang-switcher button:hover {
  opacity: 0.8;
}
</style>
